import { render } from "./StoryChangeModal.vue?vue&type=template&id=3ae48192&scoped=true"
import script from "./StoryChangeModal.vue?vue&type=script&lang=js"
export * from "./StoryChangeModal.vue?vue&type=script&lang=js"

import "./StoryChangeModal.vue?vue&type=style&index=0&id=3ae48192&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae48192"]])

export default __exports__